module.exports = __webpack_public_path__ + "media/buy-now/bag2-c7979e64.png";